import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FileService } from "./file-service";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class CollectionService {
  private API_GZ_URL = environment.API_URL + "api/resellerstatement/uploadgzcollection";
  private API_transport_URL = environment.API_URL + "api/resellerstatement/uploadtransportcollection";
  private API_pagofacil_URL = environment.API_URL + "api/resellerstatement/uploadpagofacilcollection";
  private API_transport_returns_URL = environment.API_URL + "api/transport/returns/";
  private API_single_payment_URL = environment.API_URL + "api/resellerstatement/manualpayment";
  private API_delete_payment_URL = environment.API_URL + "api/resellerstatement/deletepayment";
  private API_delete_payment_nameFile_URL = environment.API_URL + "api/resellerstatement/deletefile"
  private API_get_reseller_statment_detail_URL = environment.API_URL + "api/resellerstatement/statementDetail";
  private API_get_payments_list_URL = environment.API_URL + "api/resellerstatement/resellerPayments";
  private API_downloadFailLines_URL = environment.API_URL + "api/resellerstatement/downloadFailLines";

  constructor(private http: HttpClient, private fileService: FileService) {}

  uploadGZ(entity, element): Observable<any> {
    return this.fileService.fileUploadCollection(entity, element, this.API_GZ_URL);
  }

  uploadTranport(entity, element): Observable<any> {
    return this.fileService.fileUploadCollection(entity, element, this.API_transport_URL);
  }

  uploadPagoFacil(entity, element): Observable<any> {
    return this.fileService.fileUploadCollection(entity, element, this.API_pagofacil_URL);
  }

  uploadTransportReturn(element, id): Observable<any> {
    return this.fileService.fileUpload(element, this.API_transport_returns_URL + id);
  }

  singlePayment(debtDetail) {
    return this.http.post<any>(this.API_single_payment_URL, debtDetail);
  }

  deletePayment(paymentId) {
    return this.http.post<any>(this.API_delete_payment_URL, paymentId);
  }

  getResellerStatementDetail(userId, campaignId): Observable<any> {
    return this.http.get(this.API_get_reseller_statment_detail_URL + "/" + userId + "/" + campaignId);
  }

  getPaymentList(userId, campaignId): Observable<any> {
    return this.http.get(this.API_get_payments_list_URL + "/" + userId + "/" + campaignId);
  }

  deletePaymentWithNameFile(fileName){
    return this.http.post<any>(this.API_delete_payment_nameFile_URL + '?fileName=' + fileName,null);
  }

  downloadFailPaymentsByFileName(fileName) {
    const url = this.API_downloadFailLines_URL + '?fileName=' + fileName

    return this.http.get(url, { responseType: "blob" }).pipe(
      map((res) => {
        return new Blob([res], { type: "text/plain" });
      })
    );

}
}
